<template>
  <v-app dark>
    <div class="heading">
      <v-img :src="require('./assets/option3.jpeg')"></v-img>
    </div>

    <!-- <div class="abc"></div> -->
    <v-layout class="appToolbarContainer" wrap justify-space-between>
      <v-flex lg2 xs5 class="text-xs-center">
        <v-btn block class="appToolbarButton" to="/#people">
          <div class="appToolbarText">People</div>
        </v-btn>
      </v-flex>
      <v-flex lg2 xs5 class="text-xs-center">
        <v-btn block class="appToolbarButton" to="/stories">
          <div class="appToolbarText">Stories</div>
        </v-btn>
      </v-flex>
      <v-flex lg2 xs5 class="text-xs-center">
        <v-btn block class="appToolbarButton" to="/">
          <div class="appToolbarText">Home</div>
        </v-btn>
      </v-flex>
      <v-flex lg2 xs5 class="text-xs-center">
        <v-btn block class="appToolbarButton" to="/data">
          <div class="appToolbarText">Data</div>
        </v-btn>
      </v-flex>
      <v-flex lg2 xs5 class="text-xs-center">
        <v-btn block class="appToolbarButton" to="/tchaer">
          <div class="appToolbarText">Tchær</div>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-content >
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      dataLink:
        "https://firebasestorage.googleapis.com/v0/b/souvenirsofconflict.appspot.com/o/data%2Fsouvenirsofconflict-data-20190502.xlsx?alt=media&token=05388923-4368-4658-a382-8b971a66d7f1",
      tchaerLink: "https://frsqz.itch.io/tchr"
    };
  },
  methods: {
    dataDownload() {
      window.open(this.dataLink, "_blank");
    },
    tchaer() {
      window.open(this.tchaerLink, "_blank");
    }
  }
};
</script>
<style>
.rabbit-lyrics__line--active {
  color: #e53d3d !important; 
  font-size: 1.2rem;
}
</style>
<style lang="stylus" scoped>
.appToolbarContainer {
  display: flex;
  justify-content: center;
  max-height: 11rem;
}

.appToolbarText {
  font-family: 'Bree Serif', serif;
}

.appToolbarButton {
  padding: 2.2rem;
  font-size: 1.3rem;
}

.appToolbarTransform {
  // transform: translateY(-0.8rem)
}

.abc {
  background-image: url('./assets/army-silhoutte.svg');
  background-size: 400px 80px;
  background-repeat: repeat-x;
  width: 100%;
  height: 80px;
  margin: 20px 0;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .heading {
    width: 95vw;
    font-size: 3.8rem;
    text-align: center;
    font-family: 'Cormorant Unicase', serif;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .heading {
    width: 100vw;
    font-size: 4.4rem;
    text-align: center;
    font-family: 'Cormorant Unicase', serif;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .heading {
    width: 100vw;
    font-size: 5.6rem;
    text-align: center;
    font-family: 'Cormorant Unicase', serif;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .heading {
    width: 100vw;
    font-size: 7rem;
    text-align: center;
    font-family: 'Cormorant Unicase', serif;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1270px) {
  .heading {
    width: 100vw;
    font-size: 8rem;
    text-align: center;
    font-family: 'Cormorant Unicase', serif;
  }
}
</style>
